import { render, staticRenderFns } from "./logItem.vue?vue&type=template&id=8db80bdc&scoped=true&"
import script from "./logItem.vue?vue&type=script&lang=js&"
export * from "./logItem.vue?vue&type=script&lang=js&"
import style0 from "./logItem.vue?vue&type=style&index=0&id=8db80bdc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db80bdc",
  null
  
)

export default component.exports